import { useState } from 'react';
import { FormikProps, FormikValues } from 'formik';
import type { Step } from './types';

export const useStepper = (baseSteps: Step[]) => {
  const [steps] = useState(baseSteps);
  const [currentIndex, setCurrentIndex] = useState(0);

  const goNext = () => {
    setCurrentIndex((oldIndex) => oldIndex + 1);
  };
  const goBack = () => {
    setCurrentIndex((oldIndex) => oldIndex - 1);
  };

  const renderCurrentStep = (form: FormikProps<FormikValues>, isLoading: boolean) => {
    const step = steps[currentIndex];

    // opportunity to extend commonProps here with other relevant information
    const commonProps = {
      id: step.id,
      label: step.label,
      form,
      isLoading,
    };

    const StepComponent = step.component;

    return <StepComponent {...commonProps} />;
  };

  return {
    steps,
    currentIndex,
    goBack,
    goNext,
    renderCurrentStep,
  };
};
